import { EMPTY_OBJECT } from '../../../constants/common'

import { EntityProfileHeaderTextBase } from './EntityProfileHeaderTextBase'
import { EntityProfileHeaderTextClamped } from './EntityProfileHeaderTextClamped'
import { EntityProfileHeaderTextPlain } from './EntityProfileHeaderTextPlain'

function EntityProfileHeaderText({
  clampLines,
  editable,
  isOpen,
  ...restProps
}) {
  return clampLines && isOpen ? (
    <EntityProfileHeaderTextClamped
      {...restProps}
      {...(editable ? EMPTY_OBJECT : { EditButton: null })}
      clampLines={clampLines}
    />
  ) : editable ? (
    <EntityProfileHeaderTextPlain
      {...restProps}
      {...(editable ? EMPTY_OBJECT : { EditButton: null })}
      clampLines={clampLines}
      isOpen={isOpen}
    />
  ) : (
    <EntityProfileHeaderTextBase
      {...restProps}
      clampLines={clampLines}
      isOpen={isOpen}
    />
  )
}

export default EntityProfileHeaderText
